import { ChangeDetectionStrategy, Component, input, computed } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ImageTag } from 'src/app/components/banner/banner.component';
import { Banner, ClickActionChoices } from 'src/app/home/models/home.model';

@Component({
  standalone: true,
  selector: 'banner-variant',
  templateUrl: './banner-variant.component.html',
  styleUrls: ['./banner-variant.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterModule]
})
export class BannerVariantComponent {

  readonly banner = input<Banner>({} as Banner);

  readonly layoutCardUrl = computed(() => {
    const bannerData = this.banner();
    if (!bannerData?.images?.length) {
      return null;
    }
    return bannerData.images.find(image => image?.tag === ImageTag.layoutCard)?.url || '';
  });

  ClickActionChoices = ClickActionChoices;

}



